/**
 * Tap feedback for buttons whose hover styles live inside @media (hover: hover).
 *
 * Touch devices never fire :hover, and iOS Safari does not reliably apply
 * :active to elements that have no touch listener, so an .is-tapping class is
 * toggled on pointer events instead. The matching styles live in theme.css
 * under @media (hover: none).
 *
 * Listeners are delegated from document because cart.js replaces the whole
 * <cart-drawer-products-recommendation> element after every cart update.
 *
 * The complementary slider on the PDP is handled separately in pdp-custom.js.
 */
(function () {
  var TAP_SELECTOR = '.cart-drawer-products-recommendation .product-card__atc';
  var HOLD_MS = 260; // keep the fill visible for a beat after the finger lifts
  var tapTimer;

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.pointerType === 'mouse') return;
      var btn = e.target && e.target.closest ? e.target.closest(TAP_SELECTOR) : null;
      if (!btn) return;
      clearTimeout(tapTimer);
      btn.classList.add('is-tapping');
    },
    { passive: true }
  );

  function releaseTap() {
    var tapped = document.querySelectorAll(TAP_SELECTOR + '.is-tapping');
    if (!tapped.length) return;
    clearTimeout(tapTimer);
    tapTimer = setTimeout(function () {
      tapped.forEach(function (el) {
        el.classList.remove('is-tapping');
      });
    }, HOLD_MS);
  }

  ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (evt) {
    document.addEventListener(evt, releaseTap, { passive: true });
  });
})();